/**
 * Calculates the total surcharge amount from a list of transactions
 * @param {Array} transactions - Array of transaction objects
 * @returns {string} - Total surcharge amount formatted to 2 decimal places
 */

export const calculateTotalSurcharge = (transactions = []) => {
  if (!Array.isArray(transactions) || transactions.length === 0) {
    return '0.00';
  }

  const totalSurcharge = transactions.reduce((total, transaction) => {
    let surchargeAmount = 0;

    // Check various possible locations for surcharge data
    if (transaction?.surchargeAmount) {
      surchargeAmount = Number(transaction.surchargeAmount) || 0;
    } 

    return total + surchargeAmount;
  }, 0);
  return totalSurcharge.toFixed(2);
};
